export default __webpack_public_path__ + "static/token_holder_tablet@2x-affda8a166e84adbcef4f50b4ceac7d8.png";